<template>
	<div>
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>计划管理</el-breadcrumb-item>
			<el-breadcrumb-item>工单管理</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="form-bar">
			<el-row>
				<el-col :span="18">
					<el-form :inline="true">
						<el-form-item label="时间范围">
							<DateRange v-model="dateRange" />
						</el-form-item>
						<el-form-item>
							<el-button type="info" @click="query">工单查询</el-button>
						</el-form-item>
					</el-form>
				</el-col>
				<el-col :span="6" style="text-align:right;">
					<el-button type="primary" @click="entry()">人工录入</el-button>
					<el-button type="primary" @click="upload">导入工单</el-button>
				</el-col>
			</el-row>
		</div>
		<el-table border v-loading="loading" :data="tableData">
			<el-table-column type="index" label="序号" width="50"></el-table-column>
			<el-table-column prop="code" label="工单号">
				<template slot-scope="scope">
					<el-link @click="edit(scope.row)" v-text="scope.row.code"></el-link>
				</template>
			</el-table-column>
			<el-table-column prop="product_id" label="产品" width="180">
				<template slot-scope="scope">
					<span v-if="scope.row.product_id" v-text="scope.row.product_name"></span>
				</template>
			</el-table-column>

			<el-table-column label="计划开始时间" width="180">
				<template slot-scope="scope">
					<span v-text="timeStampFormat(scope.row.plan_begin_time)"></span>
				</template>
			</el-table-column>
			<el-table-column label="计划结束时间" width="180">
				<template slot-scope="scope">
					<span v-text="timeStampFormat(scope.row.plan_end_time)"></span>
				</template>
			</el-table-column>
			<el-table-column prop="total_len" label="工单总米数" width="110"></el-table-column>
			<el-table-column prop="roll_len" label="每卷米数" width="100"></el-table-column>
			<el-table-column prop="jt_name" label="生产机台" width="120"></el-table-column>
			<el-table-column prop="plates" label="托盘数" width="80"></el-table-column>
			<el-table-column prop="pre_time" label="准备时间" width="80"></el-table-column>
			<el-table-column label="当前工序" width="180">
				<template slot-scope="scope">
					<div v-html="formatProcessInfo(scope.row)"></div>
				</template>
			</el-table-column>
			<el-table-column label="操作" width="200" fixed="right">
				<template slot-scope="scope">
					<el-button type="text" @click="openRelationDialog(scope.row)">关联产品</el-button>
					<el-divider direction="vertical"></el-divider>
					<el-button type="text" @click="handleProcessSet(scope.row)" :disabled="!scope.row.product_id">设定工序</el-button>
					<el-divider direction="vertical"></el-divider>
					<el-tooltip content="删除工单">
						<el-popconfirm title="确定删除吗？" @onConfirm="handleDelete(scope.row)">
							<el-button type="text" icon="el-icon-delete" slot="reference"></el-button>
						</el-popconfirm>
					</el-tooltip>
				</template>
			</el-table-column>
		</el-table>

		<!--分页-->
		<el-pagination layout="total,sizes, prev, pager, next" :page-count="pageCount" :page-sizes="[10, 50, 100, 200]" :size="pageSize" @current-change="handleCurrentChange" @size-change="handleSizeChange"></el-pagination>

		<!--录入工单-->
		<el-dialog :title="this.dialog.entry.title" :visible.sync="dialog.entry.visible" width="500px">
			<work-sheet-edit-form @worKEditForm="save" ref="EditForm" v-model="workSheetForm" />
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialog.entry.visible = false">取消</el-button>
				<el-button type="primary" :loading="saving" @click="workFrom()">保存</el-button>
			</span>
		</el-dialog>

		<!--工序设置-->
		<el-dialog title="设置工序" :visible.sync="dialog.process.visible" width="800px">
			<ProcessDetails :groupId="currentProcessGroupId" :showSelect="true" v-on:select="setProcess" />
		</el-dialog>

		<el-dialog title="关联产品" :visible.sync="dialog.relation.visible" width="800px">
			<ProductDialogList v-on:selectProduct="handleSelectProduct" v-bind:product_id="currentWorksheet.product_id"></ProductDialogList>
		</el-dialog>
	</div>
</template>

<script>
	import DateRange from '@/components/DateRangePicker'
	import workSheetEditForm from './WorksheetEditForm'
	import { jobOrderRequest } from '@/network/requests/jobOrder'
	import { formatDate, formatExcelDateTime } from '@/util/datetime'
	import { jtInfoRequest } from '@/network/requests/jtInfo'
	import ProductDialogList from './ProductDialogList'
	import { processGroupRequest } from '@/network/requests/processGroup'
	import { processGroupDetailRequest } from '@/network/requests/processGroupDetail'
	import { processInfoRequest, getProcessByIdArray, getDirectionName } from '@/network/requests/processInfo'

	import moment from 'moment'
	import { productRequest } from '@/network/requests/product'
	import ProcessDetails from '@/components/ProcessDetails'
	export default {
		name: 'worksheet',
		components: {
			DateRange,
			workSheetEditForm,
			// ProcessGroupList,
			ProductDialogList,
			ProcessDetails,
		},
		data() {
			return {
				dateRange: [],
				dialog: {
					entry: {
						title: '',
						visible: false,
					},
					relation: {
						visible: false,
					},
					process: {
						visible: false,
					},
				},
				workSheetForm: {
					plan_begin_time: {
						$date: '',
					},
					plan_end_time: {
						$date: '',
					},
					code: '',
					roll_len: '',
					total_len: '',
					roll_num: '',
					jt_id: '',
				},
				processData: [],
				tableData: [],
				pageSize: 10,
				pageIndex: 1,
				pageCount: 1,
				loading: false,
				currentWorksheet: {
					product_id: '',
				},
				processTableLoading: false,
				importTableData: [],
				saving: false,
				jtList: [],
				productList: [],
				processList: [],
				processGropuDetailList: [],
				currentProcessGroupId: '',
				total: 0,
			}
		},
		methods: {
			/**
			 * 人工录入，显示录入表单。
			 */
			entry() {
				this.workSheetForm = {
					plan_begin_time: {
						$date: '',
					},
					plan_end_time: {
						$date: '',
					},
				}
				this.dialog.entry.title = '人工录入'
				this.dialog.entry.visible = true
			},
			/**
			 * 编辑工单。
			 */
			edit(row) {
				this.dialog.entry.visible = true
				this.dialog.entry.title = '编辑工单'
				this.workSheetForm = { ...row }
			},
			/**
			 * 表单验证
			 */
			workFrom() {
				if (this.saving) return
				this.$refs.EditForm.editform()
			},
			/**
			 * 保存工单。
			 */
			save() {
				if (this.saving) {
					return
				} else {
					this.saving = true
				}

				var p = null
				if (this.dialog.entry.title == '编辑工单') {
					p = jobOrderRequest.modifyById(this.workSheetForm._id.$oid, this.workSheetForm)
				} else if (this.dialog.entry.title == '人工录入') {
					p = jobOrderRequest.upload(this.workSheetForm)
				} else {
					this.$message({
						type: 'error',
						$message: '请求错误，亲重试',
					})
				}

				p.then(res => {
					console.log('保存工单结果', res)
				}).finally(() => {
					this.dialog.entry.visible = false
					this.loadData()

					setTimeout(() => {
						this.saving = false
					}, 1000)
				})
			},
			/**
			 * 导入。
			 */
			upload() {
				this.$router.push({ name: 'joborderImport' })
			},
			/**
			 * 删除工单。
			 */
			handleDelete(row) {
				jobOrderRequest
					.deleteById(row._id.$oid)
					.then(res => {})
					.finally(() => {
						this.loadData()
					})
			},
			/**
			 * 查询。
			 */
			query() {
				this.pageIndex = 1
				this.loading = true

				var filter = undefined
				if (this.dateRange) {
					filter = {
						plan_begin_time: {
							$gte: { $date: new Date(this.dateRange[0]).getTime() },
						},
						plan_end_time: {
							$lte: { $date: new Date(this.dateRange[1]).getTime() },
						},
					}
				}

				this.loadData(filter)
			},
			/**
			 * 加载数据。
			 */
			loadData(filter) {
				jobOrderRequest
					.queryPage({ pagesize: this.pageSize, page: this.pageIndex, filter })
					.then(res => {
						this.pageCount = res.data._total_pages
						this.total = res.data._size
						var orders = res.data._embedded

						const array = []

						//给工单的机台名称赋值。
						orders.forEach((v, i) => {
							var filterResult = this.jtList.filter(p => p._id.$oid == v.jt_id)
							if (filterResult) {
								var jt = filterResult[0]
								if (jt) {
									v.jt_name = jt.name
								} else {
									v.jt_name = ''
								}
							} else {
								v.jt_name = ''
							}

							//产品。
							var product = this.productList.find(t => t._id.$oid == v.product_id)
							if (product) {
								v.product_name = product.name
							}

							array.push(v)
						})

						this.tableData = array
					})
					.finally(() => {
						this.loading = false
					})
			},
			/**
			 * 改变记录数量。
			 */
			handleSizeChange(pageSize) {
				this.pageSize = pageSize
				this.pageIndex = 1
				this.loading = true
				this.loadData()
			},
			/**
			 * 选择页码事件。
			 */
			handleCurrentChange(pageIndex) {
				this.pageIndex = pageIndex
				this.loading = true
				this.loadData()
			},
			/**
			 * timeStamp格式化。
			 */
			timeStampFormat(timeStamp) {
				return formatDate(timeStamp)
			},
			/**
			 * 设置工序。
			 */
			handleProcessSet(row) {
				this.currentWorksheet = row
				this.currentProcessGroupId = ''
				if (row.product_id) {
					var product = this.productList.find(t => t._id.$oid == row.product_id)
					if (product.process_group_id) {
						this.currentProcessGroupId = product.process_group_id
					}
				}

				this.dialog.process.visible = true
			},
			/**
			 * 设置工序
			 */
			setProcess({ index, row }) {
				var joborder_id = this.currentWorksheet._id.$oid
				jobOrderRequest
					.modifyById(joborder_id, {
						process_index: index,
					})
					.then(res => {
						this.dialog.process.visible = false
					})
					.finally(() => {
						this.loadData()
					})
			},
			/**
			 * 格式化工序名称。
			 */
			formatProcessInfo(row) {
				var text = ''
				var groupId = ''
				if (row.product_id) {
					var product = this.productList.find(t => t._id.$oid == row.product_id)
					groupId = product.process_group_id
				}

				if (groupId) {
					var processList = this.processGropuDetailList.filter(t => t.process_group_id == groupId)
					processList.sort((a, b) => {
						return a.sequence - b.sequence
					})

					if (row.process_index < processList.length) {
						var processDetails = processList[row.process_index]
						var processId = processDetails.process_id
						var process = this.processList.find(t => t._id.$oid == processId)

						if (process) {
							text = `<div>${process.name}</div><small class="tip">${this.getDirectionName(process.is_end_in)}</small>`
						}
					}
				}

				return text
			},
			/**
			 * 获取工序方向。
			 */
			getDirectionName(value) {
				return getDirectionName(value)
			},
			/**
			 * 关联产品。
			 */
			openRelationDialog(row) {
				this.currentWorksheet = row
				this.dialog.relation.visible = true
			},
			/**
			 * 选择产品。
			 */
			handleSelectProduct(row) {
				this.currentWorksheet.product_id = row._id.$oid
				this.loading = true
				jobOrderRequest.modifyById(this.currentWorksheet._id.$oid, this.currentWorksheet).then(res => {
					this.loadData()
				})
			},
		},
		created() {
			this.loading = true

			//获取所有机台。
			var p1 = jtInfoRequest.queryAll()
			//查询所有的工序组详情。
			var p2 = processGroupDetailRequest.queryAll()
			//查询所有的工序。
			var p3 = processInfoRequest.queryAll()
			//查询所有产品。
			var p4 = productRequest.queryAll()

			Promise.all([p1, p2, p3, p4])
				.then(res => {
					this.jtList = res[0]
					this.processGropuDetailList = res[1]
					this.processList = res[2]
					this.productList = res[3]
				})
				.then(res => {
					this.loadData()
				})
		},
	}
</script>

<style lang="less" scoped></style>
